import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: CreateCampaignInput!) {
    createCampaign (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Campaigns/NewMutation.js